import React, { Component } from 'react';
import utilFunction from '../../containers/function';
import LineChart from '../common/graphs/crossfilterGraphs/lineChart';

const FulfillmentAtRiskEvolutionGraphModalTwo = props => (
  <div className="container-driver-graph ab stop">
    <div className="dc-chart-parent evolution-graph">
      <LineChart
        id={'driver-at-risk-evolution-graph-modaltwo'}
        additionalCrossfilterData={null}
        crossfilerData={utilFunction.generateCrossfilter(props.data)}
        stack={false}
        dimension={{
          formatFunction: [],
          name: 'date',
          originalName: 'date',
          reduceFunction: { type: 'CONTINUOUS_GROUP', typeof: 'DATE_TIME' }
        }}
        metrics={[
          {
            config: {},
            filter: [],
            formatFunction: [],
            metric: 'percentage',
            name: 'percentage',
            reduceFunction: { type: 'AVG' },
            type: 'AVG'
          }
        ]}
        config={{
          tooltip: {
            valuesConfig: [
              {
                identifier: 'x',
                valueFormat: { type: 'DATE_TIME_UTC', format: '%d-%m-%Y' },
                wrapper: '<div>%v</div>'
              },
              {
                identifier: 'y',
                valueFormat: { type: 'NUMBER', format: '.0f' },
                wrapper: "<div>En riesgo: <span style='font-weight:bold;'>%v%</span></div>",
                colorRange: [
                  { color: '#E14D57', range: [{ value: 50, operator: '<' }] },
                  {
                    color: '#EC932F',
                    range: [{ value: 50, operator: '>=' }, { value: 85, operator: '<' }]
                  },
                  { color: '#71B37C', range: [{ value: 85, operator: '>=' }] }
                ]
              }
            ]
          },
          renderArea: true,
          interpolation: 'linear',
          stroke: 2.4,
          colors: ['#fe7c00'],
          dataPoints: { show: true, radius: 3 },
          xAxis: { show: true, interval: 1, intervalDateUnit: 'DAY', format: '%d-%m', rotation: 0 },
          yAxis: {
            show: true,
            horizontalLines: false,
            ticksNumber: 2,
            format: '.0f',
            autoRange: { active: false, max: 100, min: 0 }
          }
        }}
        dashboardId={'detail_fulfillment'}
      />
    </div>
  </div>
);

export default FulfillmentAtRiskEvolutionGraphModalTwo;



// WEBPACK FOOTER //
// ./source/client/components/driver_fulfillment/evolutionGraphModalTwo.jsx